import { POST, GET, DELETE, action } from "."
import { API_ROOT_URL } from "../requests"
import axios from "axios"
import isEqual from "lodash-es/isEqual"

import { getUser } from "../requests/user"
import { createAuth } from "./auth"

export const FETCH_USERS = "FETCH_USERS"
export const ADD_USER = "ADD_USER"
export const EDIT_USER = "EDIT_USER"
export const DELETE_USER = "DELETE_USER"

export function fetchUsers() {
  const url = `${API_ROOT_URL}/admin/groups/`
  return action(GET, url, FETCH_USERS, null, ({ data }) => data)
}


export function addUser(user, onScuccess) {
  const url = `${API_ROOT_URL}/users/`
  return action(POST, url, ADD_USER, user, onScuccess)
}

export async function editUser(userId, data) {
  const url = `${API_ROOT_URL}/users/${userId}/`
  await axios.put(url, data)
}

export function deleteUser(userId, onScuccess) {
  const url = `${API_ROOT_URL}/users/${userId}/`
  return action(DELETE, url, DELETE_USER, {}, onScuccess)
}

export const updateUserInfo = () => async (dispatch, getState) => {
  const { auth } = getState()
  const { data: updatedUser } = await getUser(auth.user.userId)
  if(!isEqual(updatedUser, auth.user)) {
    dispatch(createAuth(updatedUser, auth.token))
  }
}
